// BHP-1073: shown when the post-login account bootstrap (GET /api/accounts) fails
// — a network error, an expired/invalid token, a 5xx, or a timeout (see BHP-1072
// slow local calls). A failed bootstrap must NOT be treated as "account without
// customer": that would drop a user who already has a customer into onboarding.
// Offers a retry instead of a dead end.

interface Props {
  /** Re-runs the account bootstrap query. */
  onRetry: () => void;
}

export default function AccountBootstrapError({ onRetry }: Props): JSX.Element {
  return (
    <div role="alert" className="account-bootstrap-error">
      <h1>Something went wrong</h1>
      <p>We could not load your account. Please try again.</p>
      <button type="button" onClick={onRetry}>
        Retry
      </button>
    </div>
  );
}
